import { ApplicationState, IoState, isDone } from "#store/types";
import { TableResultMap } from "#store/tables";
import { DatasourceDto } from "#services/pilotService/types";
import { createSelector } from "reselect";

export const selectDatasourcesIoState: (
    state: ApplicationState
) => IoState<DatasourceDto[]> = (state: ApplicationState) => {
    return state.datasources.data;
};

export const selectDatasources = createSelector(
    [selectDatasourcesIoState],
    (iostate: IoState<DatasourceDto[]>) => {
        if (isDone(iostate)) {
            return iostate.payload;
        } else {
            return [];
        }
    }
);
